import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuth } from '../../../hooks/useAuth';

import { ReactComponent as ArrowLeftIcon } from '../../../icons/arrow-left.svg';

import './checkout-auth-gate.scss';

import { isValidZAPhone } from '../../../utils/phone/phone';
import { Button } from '../../common/button/Button';
import { PhoneInput } from '../../common/phone-input/PhoneInput';

const GuestForm = ({ onSubmit, loading }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [errors, setErrors] = useState({});

  const validate = () => {
    const e = {};
    if (!name.trim()) e.name = 'Name is required';
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) e.email = 'Valid email required';
    if (!isValidZAPhone(phone)) e.phone = 'Valid phone number required';
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) onSubmit(name.trim(), email, phone);
  };

  return (
    <form className="cag__guest-form" onSubmit={handleSubmit}>
      <div className="cag__field">
        <label className="cag__label">Name</label>
        <input
          type="text"
          className={`cag__input ${errors.name ? 'cag__input--error' : ''}`}
          placeholder="Your name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        {errors.name && <span className="cag__field-error">{errors.name}</span>}
      </div>
      <div className="cag__field">
        <label className="cag__label">Email address</label>
        <input
          type="email"
          className={`cag__input ${errors.email ? 'cag__input--error' : ''}`}
          placeholder="you@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        {errors.email && <span className="cag__field-error">{errors.email}</span>}
      </div>
      <div className="cag__field">
        <label className="cag__label">Phone number</label>
        <PhoneInput value={phone} onChange={setPhone} hasError={!!errors.phone} />
        {errors.phone && <span className="cag__field-error">{errors.phone}</span>}
      </div>
      <Button disabled={loading}>{loading ? 'Please wait…' : 'Continue to payment'}</Button>
    </form>
  );
};

export const CheckoutAuthGate = () => {
  const { signInAsGuest, loading } = useAuth();
  const navigate = useNavigate();
  const [mode, setMode] = useState('choose'); // 'choose' | 'guest'

  const handleGuestSubmit = async (name, email, phone) => {
    await signInAsGuest(email, phone, name);
  };

  const handleSignIn = () => {
    navigate('/login', { state: { from: { pathname: '/' } } });
  };

  if (mode === 'guest') {
    return (
      <div className="cag">
        <button className="cag__back" onClick={() => setMode('choose')}>
          <ArrowLeftIcon width={14} height={14} />
          Back
        </button>
        <h2 className="cag__title">Guest checkout</h2>
        <p className="cag__sub">We'll send your order confirmation to this email.</p>
        <GuestForm onSubmit={handleGuestSubmit} loading={loading} />
      </div>
    );
  }

  return (
    <div className="cag">
      <h2 className="cag__title">How would you like to continue?</h2>
      <div className="cag__options">
        <button className="cag__option" onClick={() => setMode('guest')}>
          <span className="cag__option-title">Guest checkout</span>
          <span className="cag__option-sub">Email &amp; phone number, no account needed</span>
          <span className="cag__option-note">Limited-availability promotions won't apply to guest orders</span>
        </button>
        <button className="cag__option" onClick={handleSignIn}>
          <span className="cag__option-title">Sign in</span>
          <span className="cag__option-sub">Use your existing account</span>
        </button>
      </div>
    </div>
  );
};
